// src/suggestionRules.js

const suggestionRules = {
  "Groceries": [
    "grocery",
    "groceries",
    "supermarket",
    "market",
    "fresh market",
    "aldi",
    "safeway",
    "kroger",
    "heb",
    "whole foods",
    "trader joe",
    "costco",
    "sam's club",
    "publix",
    "hy-vee",
    "food lion",
    "sprouts",
    "alcohol",
    "beer",
    "wine",
    "liquor",
    "beverage",
    "lucky's beverage",
    "package store",
    "package",
    "abc",
    "instacart",
    "walmart",
    "wal-mart",
    "wal mart",
    "winn dixie",
    "piggly wiggly",
    "raley's",
    "vons",
    "meijer",
    "wegmans",
    "stop & shop",
    "giant food",
    "food city",
    "save-a-lot",
    "price chopper",
    "food 4 less",
    "winco",
    "firstleaf",
    "cid's",
    "cids",
    "king soopers",
    "city market",
    "basha's",
    "smith's food",
    "harmons",
    "shoppers food",
    "fresh thyme",
    "fareway",
    "martin's",
    "smart & final",
    "ralphs",
    "fred meyer",
    "qfc",
    "harris teeter",
    "baker's",
    "pick 'n save",
    "roundy's",
    "metro market",
    "grocery outlet",
    "supervalu",
    "el super",
    "cardenas",
    "northgate market",
    "99 ranch",
    "patel brothers",
    "h mart",
    "mitsuwa",
    "seafood market",
    "ethnic market",
    "corner market",
    "neighborhood market",
    "pantry",
    "farmers market",
    "organic market",
    "organic grocery",
    "fresh grocer",
    "produce market",
    "butcher",
    "butcher shop",
    "deli",
    "food bazaar",
    "bulk foods",
    "liquor mart",
    "total wine",
    "bevmo",
    "wine shop",
    "package liquor",
    "liquor depot",
    "beer & wine",
    "spirits",
    "bevco",
    "food co-op",
    "coop grocery",
    "amazon fresh",
    "freshdirect",
    "shipt",
    "misfits market",
    "imperfect foods",
    "gopuff",
    "corner shop",
    "same day grocery",
    "delivery grocery"
  ],
  "Restaurants": [
    "restaurant",
    "restaurants",
    "dining",
    "bar & grill",
    "steakhouse",
    "bistro",
    "pizzeria",
    "pizza",
    "mexican grill",
    "bbq",
    "brewhouse",
    "gastropub",
    "alcohol & bars",
    "brewery",
    "distillery",
    "fast food",
    "fastfood",
    "mexican",
    "mexicana",
    "cocina",
    "bar",
    "bars",
    // Common generic triggers
    "breakfast",
    "brunch",
    "deli",
    "burrito",
    "taco",
    "cantina",
    "grill",
    "eatery",
    "pub",
    "taproom",
    "food truck",
    "lounge",
    "sports bar",
    "wing bar",
    "pasta",
    "noodle",
    "sushi",
    "hibachi",
    "seafood",
    "oyster bar",
    "crab shack",
    "fish house",
    "roadhouse",
    "saloon",
    "alehouse",
    "banquet",
    "banh mi",
    "ramen",
    "poke",
    "bagel shop",
    "waffle",
    "pancake",
    "buffet",
    "hotpot",
    "kitchen",
    "joint",
    "cater",
    "banquet",
    "charhouse",
    "pit bbq",

    // Popular national chains
    "mcdonald's",
    "burger king",
    "wendy's",
    "chick-fil-a",
    "kfc",
    "popeyes",
    "bojangles",
    "canes",
    "raising cane's",
    "sonic",
    "jack in the box",
    "five guys",
    "shake shack",
    "in-n-out",
    "culver's",
    "freddy's",
    "whataburger",
    "white castle",
    "krystal",
    "steak n shake",
    "arby's",
    "subway",
    "jimmy john's",
    "jersey mike's",
    "firehouse subs",
    "quiznos",
    "penn station",
    "panera",
    "potbelly",
    "tropical smoothie",
    "smoothie king",
    "chipotle",
    "qdoba",
    "moe's",
    "taco bell",
    "del taco",
    "el pollo loco",
    "baja fresh",
    "panda express",
    "peking",
    "chinese kitchen",
    "thai kitchen",
    "p.f. chang's",
    "benihana",
    "cheesecake factory",
    "olive garden",
    "red lobster",
    "outback",
    "texas roadhouse",
    "longhorn",
    "ruby tuesday",
    "applebee's",
    "tgi friday's",
    "chilies",
    "buffalo wild wings",
    "hooters",
    "wings & rings",
    "pizza hut",
    "marco's pizza",
    "godfather's",
    "sbarro",
    "cici's pizza",
    "blaze pizza",
    "mod pizza",
    "round table",
    "mellow mushroom",
    "red robin",
    "smashburger",
    "fuddruckers",
    "ihop",
    "denny's",
    "waffle house",
    "cracker barrel",
    "perkins",
    "first watch",
    "black bear diner",
    "golden corral",
    "sweetgreen",
    "cava",
    "zaxby's",
    "wingstop",
    "pita pit",
    "jeremiah's italian ice",
    "keke's",
    "mellow mushroom",
    "cheddar's",
    "bonefish grill",
    "yard house",
    "cooper's hawk",
    "sizzler",
    "fleming's",
    "ruth's chris",
    "morton's",
    "capital grille",
  ],
  "Coffee Shops": [
    // Generic triggers & common words
    "coffee",
    "cafe",
    "espresso",
    "brew",
    "java",
    "bean",
    "roaster",
    "roastery",
    "barista",
    "cappuccino",
    "latte",
    "mocha",
    "americano",
    "flat white",
    "pour over",
    "drip",
    "cold brew",
    "iced coffee",
    "chai latte",
    "matcha",
    "tea house",
    "tea bar",
    "kaffe",
    "local coffee",

    // National & international chains
    "starbucks",
    "dunkin",
    "dunkin donuts",
    "peet's",
    "tim hortons",
    "caribou coffee",
    "blue bottle",
    "philz",
    "coffeebean",
    "coffee bean & tea leaf",
    "biggby",
    "second cup",
    "tully's",
    "pret a manger",
    "joe & the juice",
    "gregorys coffee",
    "lavazza",
    "intelligentsia",
    "stumptown",
    "verve coffee",
    "ritual coffee",
    "black rock coffee",
    "dutch bros",
    "black rifle coffee",
    "gloria jean's",
    "bulletproof coffee",
    "colectivo",
    "luckin coffee",

    // Regional chains & indie shop cues
    "muddhouse",
    "brewlab",
    "mojo coffee",
    "kaldi's",
    "octane coffee",
    "fox coffee",
    "storyville",
    "grounds",
    "common grounds",
    "morning joe",
    "daily grind",
    "cup o' joe",
    "java hut",
    "latte lounge",
    "espresso bar",
    "coffee roasters",
    "hipster cafe",
    "artisan coffee",
    "coffee stand",
    "coffee kiosk",
    "drive-thru coffee",
    "local coffee"
  ],
  "Delivery & Takeout": [
    "doordash",
    "uber eats",
    "grubhub",
    "postmates",
    "takeout",
    "food delivery",
    "delivery",
    // Major delivery platforms
    "doordash",
    "door dash",
    "uber eats",
    "ubereats",
    "grubhub",
    "postmates",
    "seamless",
    "deliveroo",
    "just eat",
    "skip the dishes",
    "menulog",
    "glovo",
    "zomato",
    "foodpanda",

    // Generic service descriptors
    "takeout",
    "take-out",
    "food delivery",
    "delivery",
    "online order",
    "pickup order",
    "curbside",
    "carryout",
    "click & collect",
    "mobile order",
    "mobile food",
    "to-go",

    // Restaurant terms that hint delivery
    "pizza delivery",
    "pizza hut delivery",
    "dominos",
    "papa johns",
    "little caesars",
    "jimmy john's",
    "subway delivery",
    "panda express delivery",
    "wingstop",
    "chipotle online",
    "panera delivery",
    "mcdonalds app",
    "burger king app",
    "kfc online",
    "chick-fil-a curbside",
    "starbucks pickup",

    // Card statement shorthand triggers
    "dd*",
    "gh*",
    "ue*",
    "pm*",
    "sl*",
    "shipt"
  ],
  "Mortgage Payment": [
    // General terms
    "mortgage",
    "home loan",
    "house payment",
    "mortgage payment",
    "property loan",
    "residential loan",
    "real estate loan",
    "mortgage installment",
    "principal payment",

    // Major lenders (US + broad)
    "wells fargo mortgage",
    "chase mortgage",
    "bank of america mortgage",
    "us bank mortgage",
    "citi mortgage",
    "pnc mortgage",
    "truist mortgage",
    "rocket mortgage",
    "quicken loans",
    "loan depot",
    "freedom mortgage",
    "amerihome",
    "mr cooper",
    "newrez",
    "pennymac",
    "flagstar",
    "caliber home loans",

    // Credit union / local variations
    "credit union mortgage",
    "credit union home loan",
    "federal credit union mortgage",

    // Common statement tags
    "mtg payment",
    "mort pmt",
    "mtg pmt",
    "home mtg",
    "mtge",
    "loan mtg",

    // Other hints
    "fha loan",
    "va loan",
    "conventional loan",
    "refi payment",
    "refinance payment"
  ],
  "Rent": [
    // General terms
    "rent",
    "rental",
    "rental payment",
    "rent payment",
    "monthly rent",
    "apartment rent",
    "tenant",
    "lease payment",
    "lease rent",
    "housing rent",
    "flat rent",
    "unit rent",
    "rental fee",

    // Common statement hints
    "apt rent",
    "apt pmt",
    "apt payment",
    "unit pmt",
    "unit payment",
    "lease pmt",

    // Regional terms & variations
    "condo fee",
    "dues",
    "property management",
    "property rental",
    "landlord",
    "rental agency",
    "realty rent",
    "real estate rent",

    // Major rental platforms & companies
    "zillow rental",
    "apartments.com",
    "trulia rent",
    "rentpath",
    "greystar",
    "camden property",
    "equity residential",
    "lincoln property",
    "avalonbay",
    "u-haul storage",
    "public storage rent",
    "storquest",

    // Short codes often seen on transactions
    "rent pmt",
    "rentpay",
    "rentcafe",
    "rent track",
    "tenantweb"
  ],
  "Property Taxes": [
    // General terms
    "property tax",
    "property taxes",
    "county tax",
    "real estate tax",
    "real estate taxes",
    "home tax",
    "house tax",
    "parcel tax",
    "assessment tax",
    "land tax",

    // Regional wording
    "county property tax",
    "city property tax",
    "municipal tax",
    "local tax",
    "township tax",
    "school tax",
    "school district tax",
    "school assessment",
    "county treasurer",
    "county collector",

    // Common payment hints
    "property tax payment",
    "property tax pmt",
    "property tax bill",
    "tax authority",
    "tax office",
    "tax assessor",
    "tax collector",

    // Popular US references
    "escrow tax",
    "tax escrow",
    "tax svc",
    "tax serv",  // short for 'service'
    "tax lien",
    "tax levy",

    // Variations that might show on mortgage statements
    "impound tax",
    "impound account",
    "mortgage tax payment"
  ],
  "HOA Fees": [
    // Core terms
    "hoa",
    "homeowners association",
    "hoa dues",
    "hoa fee",
    "hoa fees",
    "association dues",
    "association fee",
    "condo fee",
    "condo dues",
    "property association",
    "community association",

    // Abbreviations & short billing codes
    "h.o.a.",
    "prop assoc",
    "comm assoc",
    "hoa pmt",
    "hoa payment",
    "hoa bill",
    "hoa annual",
    "hoa quarterly",
    "hoa monthly",

    // Payment service references
    "cinc systems",   // common HOA software
    "tops software",
    "paylease",
    "clickpay",
    "smartstreet",
    "community association payment"
  ],
  "Home Insurance": [
    // Core phrases
    "home insurance",
    "homeowners insurance",
    "house insurance",
    "hazard insurance",
    "property insurance",
    "dwelling insurance",

    // Abbreviations & short forms
    "home ins",
    "prop ins",
    "dwelling ins",
    "h.o. ins",
    "h.o.i.",          // homeowners insurance abbreviation on escrow
    "haz ins",

    // Common references
    "escrow insurance",
    "insurance premium",
    "annual insurance",
    "insurance payment",

    // Vendors & companies (examples, you can grow this list)
    "state farm",
    "allstate",
    "nationwide",
    "progressive",
    "liberty mutual",
    "travelers insurance",
    "farmers insurance",
    "usaa insurance",
    "geico homeowners",
    "american family",
    "chubb insurance"
  ],
  "Home Repairs": [
    // Core repair phrases
    "home repair",
    "house repair",
    "property repair",
    "repair service",
    "maintenance repair",
    "emergency repair",
    "house maintenance",
    "home maintenance",
    "fix",

    // Common trades & professionals
    "hvac",
    "plumber",
    "plumbing",
    "electrician",
    "electrical",
    "roof repair",
    "roofer",
    "roofing",
    "contractor",
    "handyman",
    "handy man",
    "handy-man",
    "handy",
    "builder",
    "general contractor",
    "remodel",
    "renovation",
    "renovate",
    "home improvement",

    // Major stores & brands
    "home depot",
    "lowe's",
    "menards",
    "ace hardware",
    "true value",
    "build.com",
    "build",
    "ferguson",
    "supplyhouse",
    "sherwin-williams",
    "floor & decor",

    // Services you might see on statements
    "gutter cleaning",
    "chimney sweep",
    "drywall",
    "painting",
    "paint",
    "flooring",
    "tile repair",
    "fence repair",
    "garage door repair",
    "window repair",
    "door repair",
    "appliance repair",
    "pest control",
    "pest removal",
    "exterminator",
    "mold removal",
    "foundation repair",

    // Vendors / payment references
    "service call",
    "repairman",
    "maintenance tech",
    "local handyman"
  ],
  "Lawn Care": [
    // Core lawn care & gardening
    "landscaping",
    "landscaper",
    "lawn care",
    "lawn service",
    "yard work",
    "yard service",
    "mowing",
    "grass cutting",
    "grass service",
    "weed control",
    "weed removal",
    "tree service",
    "tree trimming",
    "tree removal",
    "branch removal",
    "hedge trimming",
    "bush trimming",
    "mulch",
    "mulching",
    "sod",
    "fertilizer",
    "seeding",
    "aeration",
    "irrigation",
    "sprinkler repair",
    "sprinkler service",

    // General garden & outdoor
    "garden",
    "gardening",
    "lawn & garden",
    "flower bed",
    "bed maintenance",
    "yard clean up",
    "leaf removal",
    "fall clean up",
    "spring clean up",

    // Vendors / brands / payments
    "tru green",
    "trugreen",
    "brightview",
    "scotts",
    "lawn doctor",
    "the grounds guys",
    "landcare",
    "yardbook",
    "lawn love",
    "blades of green",
    "green lawn",
    "green thumb",
    "local landscaper",
    "local lawn care",
    "property maintenance",
    "grounds maintenance"
  ],
  "Cleaning Service": [
    // Core cleaning terms
    "maid",
    "maids",
    "cleaning",
    "house cleaning",
    "cleaning service",
    "cleaner",
    "housekeeper",
    "housekeeping",
    "deep clean",
    "spring clean",
    "move out clean",
    "move in clean",
    "residential cleaning",
    "home cleaning",
    "apartment cleaning",
    "janitorial",
    "custodial",

    // Popular cleaning franchises & companies
    "molly maid",
    "the maids",
    "merry maids",
    "handy",
    "tackle",
    "tidy",
    "homeaglow",
    "two maids & a mop",
    "maidpro",
    "maid brigade",
    "sparkle clean",
    "clean house",

    // Other ways it might appear in vendor notes
    "weekly cleaning",
    "bi-weekly cleaning",
    "monthly cleaning",
    "professional cleaning",
    "domestic cleaning"
  ],
  "Electricity": [
    // General synonyms
    "electric",
    "electricity",
    "power",
    "power company",
    "power bill",
    "energy bill",
    "energy",

    // Co-op & EMC variations
    "emc",
    "electric membership corporation",
    "coop",
    "co op",
    "co-op",

    // Common electric providers (can catch local phrases too)
    "georgia power",
    "duke energy",
    "southern company",
    "pg&e",
    "pge",
    "pacific gas and electric",
    "coned",
    "con edison",
    "exelon",
    "dominion energy",
    "xcel energy",
    "aes",
    "txu energy",
    "oncor",
    "midamerican",
    "firstenergy",
    "american electric power",
    "aep",
    "next era",
    "fpl",          // Florida Power & Light
    "nyseg",
    "national grid",
    "nextera",
    "SSVEC",
    "Sulfur Springs Valley Electric",

    // Extra ways it shows up
    "electric bill",
    "light bill",
    "power payment"
  ],
  "Gas": [
    // General terms
    "gas",
    "gas bill",
    "natural gas",
    "propane",
    "heating gas",
    "fuel gas",
    "lp gas",
    "lpg",
    "butane",

    // Common utility phrases
    "gas company",
    "gas utility",
    "gas service",
    "gas payment",
    "gas charges",

    // Major US gas providers & keywords
    "piedmont natural gas",
    "southern company gas",
    "atmos energy",
    "centerpoint energy",
    "southwest gas",
    "nicor gas",
    "peoples gas",
    "north shore gas",
    "columbia gas",
    "one gas",
    "dominion energy",
    "national grid gas",
    "con edison gas",
    "washington gas",
    "oklahoma natural gas",
    "texas gas service",
    "xcel energy gas",

    // Other related
    "gas co",
    "gas line"
  ],
  "Water & Sewer": [
    // General terms
    "water",
    "water bill",
    "water utility",
    "water service",
    "wastewater",
    "waste water",
    "sewer",
    "sewer bill",
    "sewer utility",
    "sewer service",
    "stormwater",
    "storm water",

    // Common payment phrases
    "water payment",
    "sewer payment",
    "utility water",
    "utility sewer",

    // Regional water authorities & terms
    "water district",
    "water authority",
    "municipal water",
    "county water",
    "city water",
    "public works",
    "metropolitan water",
    "regional water",

    // Major US examples
    "american water",
    "aqua america",
    "california water service",
    "las vegas valley water",
    "nyc water board",
    "atlanta watershed",
    "phoenix water",
    "dc water",
    "chicago water management"
  ],
  "Internet": [
    // General terms
    "internet",
    "wifi",
    "wi-fi",
    "broadband",
    "fiber",
    "cable internet",
    "dsl",
    "gigabit",
    "fiber optic",
    "isp",
    "wireless internet",

    // Common phrases on bills
    "internet service",
    "internet bill",
    "wifi service",
    "internet payment",

    // Major ISPs and providers (US + general)
    "spectrum",
    "charter",
    "comcast",
    "xfinity",
    "cox",
    "at&t",
    "att fiber",
    "verizon fios",
    "fios",
    "google fiber",
    "centurylink",
    "frontier",
    "earthlink",
    "wow internet",
    "rcn",
    "mediacom",
    "optiwave",
    "breezeline",
    "altice",
    "optimum",
    "hughesnet",
    "viasat",
    "starlink"
  ],
  "Phone": [
    "at&t",
    "verizon",
    "tmobile",
    "t mobile",
    "t-mobile",
    "sprint",
    "boost mobile",
    "cricket wireless",
    "metro pcs",
    "metro by tmobile",
    "xfinity mobile",
    "us cellular",
    "straight talk",
    "tracfone",
    "mint mobile",
    "google fi",
    "visible",
    "cell",
    "cell phone",
    "mobile phone",
    "telephone",
    "cellular",
    "wireless",
    "mobile bill",
    "smartphone",
    "mobile service",
  ],
  "Trash / Recycling": [
    // General service terms
    "trash",
    "garbage",
    "waste",
    "waste disposal",
    "waste removal",
    "waste collection",
    "solid waste",
    "junk removal",
    "rubbish",
    "refuse",
    "landfill",
    "sanitation",
    "disposal",

    // Recycling-specific
    "recycling",
    "recyclables",
    "recycle service",
    "recycling pickup",

    // Phrases on bills
    "trash pickup",
    "trash service",
    "garbage bill",
    "waste management",
    "waste services",

    // Common vendor examples
    "wm",
    "waste management inc",
    "republic services",
    "waste pro",
    "gfl",
    "green for life",
    "advanced disposal",
    "local sanitation",
    "city waste",
    "municipal waste",
    "municipal sanitation",
    "city trash",
    "county waste"
  ],
  "Fuel": [
    // General terms
    "fuel",
    "gas",
    "gasoline",
    "petrol",
    "diesel",
    "petro",
    "motor fuel",
    "auto fuel",

    // Gas station phrases
    "gas station",
    "fuel stop",
    "truck stop",
    "service station",
    "fuel center",
    "refuel",
    "pump gas",
    "gas pump",

    // Common gas brands & retailers
    "shell",
    "chevron",
    "bp",
    "exxon",
    "mobil",
    "sunoco",
    "marathon",
    "phillips 66",
    "conoco",
    "speedway",
    "murphy usa",
    "wawa",
    "racetrac",
    "raceway",
    "pilot",
    "flying j",
    "love's",
    "circle k",
    "arco",
    "costco gas",
    "sams club gas",
    "buc-ee's",
    "qt",
    "quiktrip",
    "thorntons",
    "getgo",
    "casey's",
    "kum & go",
    "7-eleven gas",
    "holiday stationstores",
    "hess",
    "cumberland farms"
  ],
  "Auto Loan": [
    // General terms
    "auto loan",
    "car loan",
    "vehicle loan",
    "truck loan",
    "motor loan",
    "auto payment",
    "vehicle payment",
    "car payment",
    "truck payment",
    "monthly car payment",
    "monthly auto payment",

    // Financing & lender phrases
    "auto finance",
    "vehicle finance",
    "car finance",
    "auto financing",
    "vehicle financing",
    "car financing",
    "car note",
    "auto note",
    "vehicle note",
    "loan payment",

    // Common lenders & servicers
    "genesis fi",
    "ford credit",
    "toyota financial",
    "honda financial",
    "gm financial",
    "ally auto",
    "chase auto",
    "capital one auto",
    "wells fargo auto",
    "us bank auto",
    "td auto finance",
    "santander auto",
    "credit union auto",
    "navy federal auto loan",
    "penfed auto loan",
    "local credit union car loan"
  ],
  "Auto Insurance": [
    // General terms
    "auto insurance",
    "car insurance",
    "vehicle insurance",
    "truck insurance",
    "motor insurance",
    "motor vehicle insurance",
    "automobile insurance",
    "personal auto insurance",
    "vehicle coverage",
    "auto coverage",
    "car coverage",
    "auto policy",
    "car policy",
    "liability insurance",
    "full coverage",
    "comprehensive insurance",
    "collision insurance",

    // Common national carriers
    "geico",
    "state farm",
    "progressive",
    "allstate",
    "usaa",
    "farmers insurance",
    "nationwide",
    "liberty mutual",
    "american family",
    "travelers insurance",
    "safeco insurance",
    "the general",
    "esurance",
    "root insurance",
    "metromile",
    "elephant insurance",

    // Credit union & bank options
    "credit union auto insurance",
    "bank car insurance"
  ],
  "Maintenance & Repairs": [
    // General terms
    "auto maintenance",
    "auto repair",
    "car repair",
    "car maintenance",
    "vehicle repair",
    "vehicle maintenance",
    "service & parts",
    "auto service",
    "mechanic",
    "repair shop",
    "auto shop",
    "garage",
    "car shop",
    "tune up",
    "alignment",
    "inspection",
    "emissions test",
    "smog check",
    "oil change",
    "fluid change",
    "transmission service",
    "radiator service",
    "brake service",
    "brake replacement",
    "new brakes",
    "battery replacement",
    "windshield replacement",
    "glass repair",
    "parts",
    "replacement parts",
    "aftermarket parts",
    "body shop",
    "collision repair",
    "detailing",
    "car wash", // Some people lump this with maintenance

    // Common shops / chains
    "midas",
    "jiffy lube",
    "firestone",
    "goodyear",
    "pep boys",
    "ntb",
    "discount tire",
    "tire kingdom",
    "big o tires",
    "monro muffler",
    "valvoline",
    "take 5",
    "meinike",
    "grease monkey",
    "express oil change",
    "aaa auto repair",
    "les schwab",
    "costco tire",
    "sears auto",
    "dealer service",
    "ford",
    "nissan",
    "honda",
  ],
  "Parking & Tolls": [
    // General terms
    "parking",
    "park",
    "meter",
    "street parking",
    "garage",
    "parking garage",
    "lot",
    "parking lot",
    "public parking",
    "valet",
    "valet parking",
    "paid parking",
    "pay to park",
    "prk",

    // Tolls
    "toll",
    "toll road",
    "turnpike",
    "bridge toll",
    "highway toll",
    "express lane",
    "fast pass",
    "transponder",

    // Regional passes & systems
    "ez pass",
    "e-zpass",
    "sunpass",
    "peach pass",
    "fastrak",
    "i-pass",
    "texas tag",
    "ny tag",
    "good to go",
    "407 etr",
    "k-tag",
    "riverlink",
    "autopass",

    // Common vendors
    "parkmobile",
    "spot hero",
    "passport parking",
    "park whiz",
    "impark",
    "laz parking",
    "republic parking",
    "ace parking",
    "diamond parking",
    "parkme",
    "parkopedia",

    // Extra context terms
    "auto & transport",
    "vehicle toll",
    "parking fee",
    "metered parking"
  ],
  "Public Transit": [
    // General terms
    "public transit",
    "public transport",
    "transit",
    "transportation",
    "commute",
    "fare",
    "transit fare",
    "subway",
    "metro",
    "train",
    "rail",
    "light rail",
    "streetcar",
    "tram",
    "bus",
    "city bus",
    "shuttle",
    "commuter rail",
    "ferry",
    "transit pass",

    // Common systems & city terms
    "marta",      // Atlanta
    "cta",        // Chicago Transit Authority
    "nyct",       // NYC Transit
    "mta",        // NYC/Metro
    "bart",       // Bay Area
    "muni",       // San Francisco
    "septa",      // Philadelphia
    "wmata",      // DC Metro
    "dc metro",
    "sound transit",
    "tri-met",
    "metrolink",
    "metrorail",
    "vta",
    "dart",
    "rt",
    "rtp",
    "via",
    "oc transpo",
    "translink",
    "ttc",

    // Pass & card keywords
    "clipper",
    "orcacard",
    "tap card",
    "metrocard",
    "ventra",
    "contactless fare",
    "monthly pass",
    "transit card",

    // Vendors & apps
    "greyhound",
    "megabus",
    "flixbus",
    "coach usa",
    "boltbus",
    "public ferry",
    "commuter pass"
  ],
  "Rideshare": [
    "rideshare",
    "ride share",
    "ride-sharing",
    "uber",
    "lyft",
    "uber rides",
    "lyft rides",
    "uber trip",
    "lyft trip",
    "uber ride",
    "lyft ride",
    "uber x",
    "uber xl",
    "uber black",
    "uber comfort",
    "uber pool",
    "uber green",
    "uber eats delivery", // Sometimes they lump rides & eats
    "rides",
    "ride",
    "car share",
    "grab",        // popular in Asia
    "bolt",        // Europe/Africa
    "didi",        // China & global
    "ola",         // India & Australia
    "careem",      // Middle East
    "ride app",
    "trip fare",
    "cab fare",
    "taxi app",
    "taxi ride",
    "private hire",
    "private car",
    "private driver",
    "driver service"
  ],
  "Health Insurance": [
    "health insurance",
    "medical insurance",
    "hospital insurance",
    "healthcare insurance",
    "blue cross",
    "blue cross blue shield",
    "bcbs",
    "anthem",
    "cigna",
    "aetna",
    "unitedhealth",
    "united healthcare",
    "uhc",
    "kaiser",
    "kaiser permanente",
    "humana",
    "medica",
    "medicare",
    "medicaid",
    "ambetter",
    "oscar health",
    "mvp health",
    "health plan premium",
    "medical plan premium",
    "health premium",
    "insurance premium",
    "cobra",
    "health plan",
    "insurance payment",
    "insurance bill",
    "health coverage",
    "medical coverage",
    "doctor plan",
    "provider plan"
  ],
  "Doctor Visits": [
    "doctor",
    "physician",
    "primary care",
    "urgent care",
    "clinic",
    "medical office",
    "family practice",
    "family medicine",
    "pediatrician",
    "specialist",
    "internal medicine",
    "general practitioner",
    "gp",
    "medical group",
    "physician group",
    "visit fee",
    "office visit",
    "health clinic",
    "wellness visit",
    "physical exam",
    "well visit",
    "sick visit",
    "telehealth",
    "telemedicine",
    "minuteclinic",
    "walk-in clinic",
    "checkup",
    "annual exam"
  ],
  "Dental": [
    "dentist",
    "dental",
    "orthodontist",
    "braces",
    "oral surgery",
    "oral surgeon",
    "periodontist",
    "endodontist",
    "prosthodontist",
    "pediatric dentist",
    "dental care",
    "dental group",
    "dental clinic",
    "dental office",
    "family dental",
    "teeth cleaning",
    "cleaning",
    "exam & cleaning",
    "hygienist",
    "x-ray",
    "cavity",
    "fillings",
    "crowns",
    "root canal",
    "invisalign",
    "retainer",
    "tooth extraction",
    "wisdom teeth",
    "smile center",
    "smile dental",
    "orthodontics",
    "dental plan",
    "dental insurance",
    "cosmetic dentistry"
  ],
  "Vision": [
    "vision",
    "optometrist",
    "ophthalmologist",
    "eye doctor",
    "eye exam",
    "vision center",
    "lenscrafters",
    "eyeglasses",
    "contacts",
    "contact lenses",
    "glasses",
    "specs",
    "frames",
    "optical",
    "eye care",
    "vision care",
    "america's best",
    "pearl vision",
    "pearle vision",
    "eyemart",
    "visionworks",
    "myeyedr",
    "lens & frames",
    "eye test",
    "lasik",
    "lasik plus",
    "cataract surgery",
    "retina specialist",
    "cornea clinic"
  ],
  "Pharmacy": [
    "pharmacy",
    "prescription",
    "medication",
    "meds",
    "medicine",
    "rx",
    "drugstore",
    "chemist",
    "cvs",
    "walgreens",
    "rite aid",
    "duane reade",
    "walmart pharmacy",
    "costco pharmacy",
    "sams club pharmacy",
    "kroger pharmacy",
    "publix pharmacy",
    "safeway pharmacy",
    "albertsons pharmacy",
    "pill",
    "refill",
    "scripts",
    "mail order pharmacy",
    "express scripts",
    "optumrx",
    "goodrx",
    "pharmaceuticals",
    "prescription drugs",
    "pharma",
    "health mart",
    "drug mart",
    "longs drugs",
    "fred meyer pharmacy",
    "wegmans pharmacy",
    "hyvee pharmacy",
    "pills",
    "caplets",
    "tablets"
  ],
  "Life Insurance": [
    "life insurance",
    "term life",
    "whole life",
    "universal life",
    "insurance premium",
    "policy premium",
    "insurance payment",
    "mass mutual",
    "massmutual",
    "prudential",
    "state farm life",
    "state farm",
    "new york life",
    "northwestern mutual",
    "metlife",
    "aig",
    "john hancock",
    "guardian life",
    "transamerica",
    "lincoln financial",
    "protective life",
    "banner life",
    "mutual of omaha",
    "globe life",
    "ethos life",
    "haven life",
    "ladder life",
    "policygenius",
    "life policy",
    "life cover",
    "death benefit",
    "premium payment",
    "life protection",
    "family protection",
    "beneficiary"
  ],
  "Pet Insurance": [
    "pet insurance",
    "pet policy",
    "pet coverage",
    "pet health plan",
    "vet insurance",
    "veterinary insurance",
    "animal insurance",
    "healthy paws",
    "nationwide pet",
    "aspca pet",
    "trupanion",
    "petplan",
    "fetch pet",
    "figo pet",
    "embrace pet",
    "pumpkin pet",
    "metlife pet",
    "banfield",
    "petco insurance",
    "chewy pet insurance",
    "pets best",
    "paw protect",
    "paw plan",
    "vet bills",
    "pet wellness"
  ],
  "Childcare / Daycare": [
    "childcare",
    "child care",
    "daycare",
    "day care",
    "babysitting",
    "babysitter",
    "preschool",
    "nursery",
    "nanny",
    "au pair",
    "after school care",
    "before school care",
    "extended day",
    "kids academy",
    "learning center",
    "learning academy",
    "early learning",
    "early childhood",
    "pre-k",
    "pre k",
    "prek",
    "toddler program",
    "infant care",
    "infant center",
    "montessori",
    "head start",
    "early head start",
    "child development center",
    "cdc",
    "east cobb prep",
    "bright horizons",
    "kiddie academy",
    "primrose",
    "godard school",
    "kids r kids",
    "child enrichment",
    "tiny tots",
    "child minders",
    "youth center",
    "family daycare",
    "home daycare"
  ],
  "School Tuition": [
    "school tuition",
    "school",
    "private school",
    "charter school",
    "tuition payment",
    "academy",
    "prep",
    "prepatory",
    "prep school",
    "college prep",
    "montessori",
    "waldorf",
    "christian academy",
    "catholic school",
    "parochial school",
    "faith school",
    "religious school",
    "independent school",
    "elementary",
    "primary school",
    "lower school",
    "middle school",
    "junior high",
    "high school",
    "upper school",
    "boarding school",
    "tuition fee",
    "enrollment fee",
    "registration fee",
    "school fee",
    "homeschool co-op",
    "private academy",
    "learning academy",
    "education center",
    "school payment",
    "school district",
    "class fee"
  ],
  "Kids Activities": [
    "extracurricular",
    "sports league",
    "gymnastics",
    "karate",
    "taekwondo",
    "martial arts",
    "piano lessons",
    "music lessons",
    "guitar lessons",
    "voice lessons",
    "art class",
    "ballet",
    "dance class",
    "tap dance",
    "hip hop dance",
    "ballet school",
    "dance academy",
    "cheer",
    "cheerleading",
    "soccer",
    "football",
    "softball",
    "baseball",
    "basketball",
    "volleyball",
    "lacrosse",
    "hockey",
    "swim team",
    "swimming lessons",
    "tennis lessons",
    "golf lessons",
    "youth sports",
    "summer camp",
    "day camp",
    "overnight camp",
    "scouts",
    "girl scouts",
    "boy scouts",
    "kids club",
    "youth program",
    "after school program",
    "kids activities",
    "rec center",
    "recreation fee",
    "team fee",
    "club fee"
  ],
  "Summer Camps": [
    "summer camp",
    "camp fee",
    "day camp",
    "overnight camp",
    "sleepaway camp",
    "scout camp",
    "sports camp",
    "youth camp",
    "kids camp",
    "camp tuition",
    "camp deposit",
    "camp registration",
    "camp payment",
    "summer program",
    "summer session",
    "adventure camp",
    "arts camp",
    "music camp",
    "science camp",
    "nature camp",
    "outdoor camp",
    "bible camp",
    "church camp",
    "leadership camp",
    "counselor fee",
    "camp supplies",
    "camp gear"
  ],
  "Tutoring": [
    "tutor",
    "tutoring",
    "test prep",
    "test preparation",
    "exam prep",
    "education center",
    "learning center",
    "academic coach",
    "academic support",
    "homework help",
    "study help",
    "study skills",
    "private tutor",
    "one-on-one tutor",
    "group tutoring",
    "after school tutor",
    "ACT prep",
    "SAT prep",
    "GRE prep",
    "LSAT prep",
    "MCAT prep",
    "AP tutor",
    "college prep",
    "college counseling",
    "academic enrichment",
    "learning lab",
    "online tutoring",
    "virtual tutoring",
    "test",
    "testing",
    "kumon",
    "sylvan",
    "huntington learning center",
    "varsity tutors",
    "wyzant",
    "chegg tutors",
    "club z tutoring",
    "brainfuse",
    "prepped and polished",
    "ivywise",
    "princeton review",
    "kaplan test prep",
  ],
  "Gym / Fitness": [
    "gym",
    "fitness",
    "workout",
    "exercise",
    "health club",
    "health & fitness",
    "health club membership",
    "gym membership",
    "personal training",
    "trainer",
    "bootcamp",
    "fitness bootcamp",
    "crossfit",
    "spin studio",
    "cycle studio",
    "cycling",
    "yoga studio",
    "yoga",
    "pilates",
    "barre",
    "kickboxing",
    "martial arts gym",
    "mma gym",
    "boxing gym",
    "weightlifting",
    "bodybuilding",
    "strength training",
    "recreation center",
    "rec center",
    "sports club",
    "wellness center",
    "wellness membership",
    "wellness",
    "planet fitness",
    "24 hour fitness",
    "la fitness",
    "crunch fitness",
    "anytime fitness",
    "lifetime fitness",
    "orangetheory",
    "f45",
    "pure barre",
    "corepower yoga",
    "soulcycle",
    "peloton",
    "tonal",
    "mirror",
    "fitbit premium",
    "gympass",
    "gold's gym",
    "snap fitness"
  ],
  "Clothing": [
    "clothing",
    "apparel",
    "clothes",
    "boutique",
    "fashion",
    "department store",
    "menswear",
    "womenswear",
    "kidswear",
    "uniforms",
    "workwear",
    "athleisure",
    "activewear",
    "underwear",
    "lingerie",
    "swimwear",
    "outerwear",
    "shoes",
    "footwear",
    "sneakers",
    "boots",
    "hats",
    "accessories",
    "suits",
    "dress",
    "tuxedo",
    "tailor",
    "tailoring",
    "alterations",
    "mall",
    "macy's",
    "nordstrom",
    "bloomingdale's",
    "neiman marcus",
    "saks",
    "tj maxx",
    "marshall's",
    "ross",
    "kohls",
    "jcpenny",
    "sears",
    "old navy",
    "gap",
    "banana republic",
    "express",
    "h&m",
    "zara",
    "uniqlo",
    "forever 21",
    "urban outfitters",
    "anthropologie",
    "abercrombie",
    "hollister",
    "aerie",
    "american eagle",
    "victoria's secret",
    "pink",
    "lululemon",
    "nike store",
    "adidas store",
    "puma store",
    "reebok",
    "under armour",
    "rei",
    "patagonia",
    "north face",
    "carhartt",
    "work world",
    "dry cleaner",
    "dry cleaning",
    "stitch fix",
    "rent the runway",
    "thrift store",
    "goodwill",
    "plato's closet",
    "buffalo exchange",
    "poshmark"
  ],
  "Hair & Beauty": [
    "salon",
    "barber",
    "barbershop",
    "haircut",
    "hair dresser",
    "hair stylist",
    "blowout",
    "blow dry bar",
    "drybar",
    "hair color",
    "highlights",
    "balayage",
    "perm",
    "trim",
    "bang trim",
    "extensions",
    "nails",
    "nail",
    "nail salon",
    "manicure",
    "mani",
    "pedicure",
    "pedi",
    "gel nails",
    "acrylic nails",
    "nail art",
    "waxing",
    "brow wax",
    "brow bar",
    "eyebrow threading",
    "threading",
    "facial",
    "skin care",
    "spa",
    "day spa",
    "med spa",
    "cosmetology",
    "cosmetic",
    "beauty",
    "beauty bar",
    "lash bar",
    "lash extensions",
    "makeup",
    "sephora",
    "ulta",
    "sally beauty",
    "great clips",
    "supercuts",
    "sport clips",
    "fantastic sams",
    "floyd's barbershop",
    "roosters barbershop",
    "the cut",
    "hair",
    "cuts",
    "personal care",
    "cosmetic studio",
    "beauty lounge",
    "blow bar",
    "wax center",
    "european wax center",
    "massage envy",
    "massage",
    "beauty supply",
    "hair supply"
  ],
  "Subscriptions": [
    "subscription",
    "monthly subscription",
    "membership",
    "recurring fee",
    "auto-renew",
    "annual plan",
    "digital subscription",
    "streaming",
    "streaming service",
    "netflix",
    "hulu",
    "disney+",
    "disney plus",
    "hbo max",
    "max",
    "peacock",
    "paramount+",
    "paramount plus",
    "apple tv",
    "prime video",
    "amazon prime",
    "prime",
    "prime membership",
    "spotify",
    "apple music",
    "itunes",
    "apple.com",
    "apple.com/bill",
    "pandora",
    "sirius xm",
    "siriusxm",
    "sonos",
    "tidal",
    "youtube premium",
    "youtube music",
    "audible",
    "audible books",
    "scribd",
    "new york times",
    "nyt",
    "wsj",
    "wall street journal",
    "magazine",
    "online magazine",
    "news subscription",
    "medium",
    "substack",
    "patreon",
    "onlyfans",
    "google workspace",
    "microsoft 365",
    "office 365",
    "adobe",
    "adobe cloud",
    "creative cloud",
    "canva pro",
    "zoom",
    "dropbox",
    "cloud storage",
    "one drive",
    "icloud",
    "vpn",
    "nordvpn",
    "expressvpn",
    "antivirus",
    "mcafee",
    "norton",
    "playstation plus",
    "xbox live",
    "nintendo online",
    "game pass",
    "game subscription",
    "software subscription",
    "business services",
    "business service",
    "newsletter",
    "publishing",
    "mailchimp",
    "convertkit",
    "membership fee",
    "duolingo",
    "language app",
    "fitness app",
    "peloton app",
    "workout app",
    "calm",
    "headspace",
    "meditation app",
    "skillshare",
    "masterclass",
    "course subscription",
    "learning subscription",
    "linkedin premium",
    "data storage",
    "cloud subscription",
    "entertainment subscription",
    "software",
    "music subscription",
    "music",
    "ford.com"
  ],
  "Gifts": [
    "gift",
    "gifts",
    "present",
    "presents",
    "wedding gift",
    "wedding registry",
    "bridal shower gift",
    "baby shower gift",
    "birthday gift",
    "birthday presents",
    "anniversary gift",
    "holiday gift",
    "holiday presents",
    "christmas gift",
    "christmas present",
    "hanukkah gift",
    "valentine's gift",
    "valentines present",
    "housewarming gift",
    "graduation gift",
    "graduation present",
    "retirement gift",
    "farewell gift",
    "teacher gift",
    "thank you gift",
    "thank you present",
    "gift basket",
    "gift card",
    "gift certificate",
    "registry",
    "amazon gift",
    "etsy gift",
    "personalized gift",
    "engraved gift",
    "custom gift",
    "flowers",
    "florist",
    "bouquet",
    "1-800-flowers",
    "proflowers",
    "edible arrangement",
    "fruit basket",
    "wine gift",
    "chocolate gift",
    "gift shop",
    "gift store",
    "gift boutique",
    "gifting",
    "present shopping"
  ],
  "Charity": [
    "charity",
    "charities",
    "donation",
    "donations",
    "donate",
    "giving",
    "gift to charity",
    "charitable contribution",
    "nonprofit",
    "non-profit",
    "501c3",
    "church",
    "tithe",
    "tithing",
    "offering",
    "faith giving",
    "missions",
    "relief fund",
    "foundation",
    "trust",
    "humanitarian",
    "fundraiser",
    "fundraising",
    "crowdfunding",
    "gofundme",
    "donorschoose",
    "red cross",
    "salvation army",
    "united way",
    "habitat for humanity",
    "st. jude",
    "make a wish",
    "food bank",
    "animal rescue",
    "animal shelter",
    "humane society",
    "disaster relief",
    "charity event",
    "benefit event",
    "pledge",
    "donor"
  ],
  "Pet Care": [
    "vet",
    "veterinary",
    "veterinarian",
    "animal hospital",
    "animal clinic",
    "pet checkup",
    "spay",
    "neuter",
    "vaccination",
    "pet vaccination",
    "pet care",
    "pet store",
    "pet supply",
    "pet supplies",
    "pet food",
    "pet treats",
    "pet meds",
    "flea",
    "tick",
    "heartworm",
    "grooming",
    "pet grooming",
    "dog wash",
    "pet wash",
    "boarding",
    "kennel",
    "pet hotel",
    "dog hotel",
    "dog daycare",
    "cat boarding",
    "pet daycare",
    "dog walking",
    "dog walker",
    "pet sitter",
    "petsitting",
    "petco",
    "petsmart",
    "chewy",
    "barkbox",
    "petland",
    "petbarn",
    "pet supplies plus",
    "banfield",
    "bluepearl"
  ],
  "General Shopping": [
    "general shopping",
    "retail",
    "retailer",
    "superstore",
    "discount store",
    "big box store",
    "department store",
    "mall",
    "gift shop",
    "souvenir",
    "merchandise",
    "amazon",
    "prime",
    "prime purchase",
    "amazon marketplace",
    "marketplace",
    "etsy",
    "ebay",
    "overstock",
    "zulily",
    "wayfair",
    "wish",
    "aliexpress",
    "shein",
    "hosting",
    "studio",
    "art",
    "arts",
    "cultural arts",
    "craft store",
    "michaels",
    "joann",
    "hobby lobby",
    "target",
    "target superstore",
    "walmart",
    "wal mart",
    "wal-mart",
    "costco",
    "sam's club",
    "bjs",
    "five below",
    "dollar general",
    "family dollar",
    "dollar tree",
    "tj maxx",
    "marshalls",
    "ross",
    "burlington",
    "kohl's",
    "sears",
    "jcpenney",
    "macys",
    "nordstrom",
    "bloomingdale's",
    "neiman marcus",
    "photo",
    "photograph",
    "photography",
    "prints",
    "frames",
    "shutterfly",
    "snapfish",
    "vistaprint",
    "checks unlimited",
    "check",
    "chime",
    "popmoney",
    "zelle",
    "venmo",
    "paypal",
    "cash app",
    "square cash",
    "bank to bank",
    "ach transfer",
    "mobile transfer",
    "account transfer",
  ],
  "Streaming Services": [
    "streaming",
    "streaming service",
    "tv streaming",
    "internet tv",
    "internet television",
    "ott",
    "video on demand",
    "vod",
    "cable",
    "television",
    "tv",
    "netflix",
    "hulu",
    "disney+",
    "disney plus",
    "espn+",
    "espn plus",
    "max",
    "hbo max",
    "hbo",
    "paramount+",
    "paramount plus",
    "showtime",
    "starz",
    "apple tv",
    "apple tv+",
    "prime video",
    "amazon prime video",
    "youtube tv",
    "youtube premium",
    "youtube subscription",
    "peacock",
    "sling",
    "sling tv",
    "fubo",
    "philo",
    "crunchyroll",
    "funimation",
    "vrv",
    "roku",
    "roku channel",
    "pluto tv",
    "tubi",
    "freevee",
    "amc+",
    "amc plus",
    "britbox",
    "acorn tv",
    "curiositystream",
    "kanopy",
    "hoopla",
    "shudder"
  ],
  "Hobbies": [
    "hobby",
    "hobbies",
    "craft",
    "crafting",
    "craft store",
    "art",
    "art supplies",
    "arts & crafts",
    "diy",
    "do it yourself",
    "model kits",
    "model trains",
    "rc cars",
    "rc planes",
    "scale models",
    "collectibles",
    "collecting",
    "comic books",
    "comics",
    "trading cards",
    "pokemon",
    "sports cards",
    "memorabilia",
    "coin collecting",
    "stamp collecting",
    "music store",
    "guitar center",
    "sam ash",
    "sheet music",
    "music",
    "music lessons",
    "record shop",
    "vinyl",
    "scrapbooking",
    "sewing",
    "knitting",
    "crochet",
    "fabric store",
    "joann fabrics",
    "michaels",
    "hobby lobby",
    "blick art",
    "art store",
    "canvas",
    "paint supplies",
    "beads",
    "bead store",
    "woodworking",
    "homebrew",
    "brew shop",
    "bike shop",
    "bicycle shop",
    "skate shop",
    "fishing gear",
    "tackle shop",
    "hunting gear",
    "archery",
    "camping gear",
    "outdoor store",
    "rei",
    "bass pro",
    "cabela's",
    "sports",
    "sports gear",
    "sporting goods",
    "academy sports",
    "dicks sporting goods",
    "play it again sports",
    "outdoorsman",
    "fly shop",
    "surf shop",
    "kayak shop",
    "yarn shop",
    "needlepoint"
  ],
  "Events & Tickets": [
    "event",
    "events",
    "tickets",
    "ticket",
    "ticketing",
    "box office",
    "concert",
    "concerts",
    "gig",
    "live show",
    "live music",
    "festival",
    "music festival",
    "performance",
    "broadway",
    "theater",
    "theatre",
    "playhouse",
    "opera",
    "ballet",
    "comedy show",
    "comedy club",
    "sports tickets",
    "game tickets",
    "season tickets",
    "season pass",
    "amphitheater",
    "arena",
    "stadium",
    "venue",
    "sports event",
    "sporting event",
    "ticketmaster",
    "stubhub",
    "seatgeek",
    "axs",
    "vivid seats",
    "tickets.com",
    "ticketfly",
    "bandsintown",
    "eventbrite",
    "ticketweb",
    "goldstar",
    "ticketcity",
    "livenation",
    "movie tickets",
    "movie pass",
    "cinema",
    "film festival",
    "vip tickets",
    "meet and greet",
    "entertainment"
  ],
  "Vacations": [
    "vacation",
    "vacations",
    "travel",
    "trip",
    "getaway",
    "holiday",
    "holiday inn",
    "hotel",
    "motel",
    "inn",
    "resort",
    "spa resort",
    "all inclusive",
    "beach resort",
    "airbnb",
    "vrbo",
    "booking.com",
    "expedia",
    "travelocity",
    "hotels.com",
    "kayak",
    "orbitz",
    "priceline",
    "tripadvisor",
    "hopper",
    "agoda",
    "trip.com",
    "trivago",
    "flights",
    "flight",
    "airfare",
    "airline",
    "airlines",
    "airplane",
    "jet",
    "prop plane",
    "propeller",
    "delta",
    "american airlines",
    "united",
    "southwest",
    "alaska airlines",
    "jetblue",
    "frontier",
    "spirit airlines",
    "lufthansa",
    "international travel",
    "passport",
    "bus ticket",
    "bus",
    "greyhound",
    "megabus",
    "train",
    "amtrak",
    "car rental",
    "rental car",
    "road trip",
    "cruise",
    "carnival cruise",
    "royal caribbean",
    "norwegian cruise",
    "msc cruises",
    "excursion",
    "timeshare",
    "holiday travel",
    "tour package",
    "adventure travel",
    "honeymoon"
  ],
  "Travel Insurance": [
    "travel insurance",
    "trip insurance",
    "trip protection",
    "vacation insurance",
    "holiday insurance",
    "flight insurance",
    "cancellation insurance",
    "travel guard",
    "allianz travel",
    "aig travel",
    "axa assistance",
    "world nomads",
    "generali global",
    "travelex insurance",
    "travel protect",
    "travel safe",
    "insuremytrip",
    "policy",
    "cover trip",
    "travel protection plan",
    "allianz",
    "allianzins"
  ],
  "Credit Card Payments": [
    "credit card payment",
    "cc payment",
    "visa payment",
    "mastercard payment",
    "amex payment",
    "american express",
    "discover payment",
    "capital one",
    "chase payment",
    "wells fargo",
    "citibank",
    "citi card",
    "bank of america",
    "bofa",
    "barclays",
    "synchrony",
    "credit one",
    "us bank",
    "pnc bank",
    "fifth third bank",
    "td bank",
    "suntrust",
    "regions bank",
    "first premier",
    "credit card bill",
    "credit card balance",
    "finance charge",
    "interest charge",
    "late fee",
    "minimum payment",
    "payment received",
    "payment posted",
    "statement payment"
  ],
  "Student Loans": [
    "student loan",
    "student loans",
    "loan repayment",
    "education loan",
    "college loan",
    "university loan",
    "student finance",
    "navient",
    "sallie mae",
    "fedloan",
    "great lakes",
    "nelnet",
    "mohela",
    "cornerstone",
    "osla",
    "aidvantage",
    "edfinancial",
    "sofi student loan",
    "earnest student loan",
    "college ave",
    "discover student loans",
    "wells fargo student loan",
    "citizens bank student loan",
    "student loan payment",
    "loan servicer",
    "student loan repayment"
  ],
  "Personal Loans": [
    "personal loan",
    "personal finance",
    "unsecured loan",
    "loan payment",
    "loan repayment",
    "loan servicing",
    "sofi",
    "lending club",
    "upstart",
    "prosper",
    "marcus",
    "lightstream",
    "best egg",
    "avant",
    "payoff",
    "upgrade",
    "rocket loans",
    "one main financial",
    "discover personal loans",
    "citizens bank personal loan",
    "american express personal loan",
    "wells fargo personal loan",
    "personal line of credit"
  ],
  "Taxes": [
    "tax",
    "taxes",
    "government",
    "city",
    "county",
    "municipality",
    "state",
    "assessor",
    "property tax",
    "income tax",
    "irs",
    "state revenue",
    "department of revenue",
    "dor",
    "franchise tax",
    "employment tax",
    "self-employment tax",
    "federal tax",
    "state tax",
    "local tax",
    "gov",
    "registration",
    "license fee",
    "business license",
    "annual report",
    "renewal fee",
    "dmv",
    "vehicle registration",
    "vehicle tax",
    "tag fee"
  ],
  "Emergency Fund": [
    "emergency fund",
    "rainy day fund",
    "savings account",
    "high yield savings",
    "online savings",
    "reserve fund",
    "sinking fund",
    "money market",
    "capital reserve",
    "cushion",
    "buffer savings",
    "emergency savings"
  ],
  "General Savings": [
    "savings",
    "saving transfer",
    "bank transfer",
    "paypal",
    "cash reserve",
    "general savings",
    "goal savings",
    "transfer to savings",
    "high yield",
    "savings deposit",
    "ally savings",
    "capital one savings",
    "chime savings",
    "sofi savings",
    "online savings account",
    "joint savings",
    "linked savings"
  ],
  "Retirement Savings": [
    "401k",
    "roth ira",
    "traditional ira",
    "pension",
    "sep ira",
    "simple ira",
    "retirement",
    "retirement plan",
    "employer match",
    "fidelity",
    "vanguard",
    "t. rowe price",
    "charles schwab",
    "merrill lynch",
    "principal retirement",
    "transamerica",
    "retirement contribution",
    "retirement savings"
  ],
  "College Fund": [
    "529 plan",
    "college savings",
    "education fund",
    "education savings",
    "custodial account",
    "ugma",
    "utma",
    "scholarship fund",
    "college fund",
    "coverdell",
    "education ira",
    "state 529",
    "college trust"
  ],
  "Internal Transfers": [
    "internal transfer",
    "fund transfer",
    "balance transfer",
    "intra-account",
    "inter-account",

  ],
  "Reimbursements": [
    "reimbursement",
    "expense report",
    "company expense",
    "repayment",
    "payback",
    "refund",
    "rebate",
    "business expense",
    "work expense",
    "mileage reimbursement",
    "per diem",
    "travel reimbursement",
    "client expense",
    "employee reimbursement",
    "reimbursed"
  ],
  "Primary Salary": [
    "income",
    "salary",
    "payroll",
    "paycheck",
    "pay check",
    "direct deposit",
    "salary payment",
    "biweekly pay",
    "weekly pay",
    "monthly salary",
    "wages",
    "wage",
    "hr pay",
    "payroll deposit",
    "employer deposit",
    "company payroll",
    "payroll credit",
    "employment income",
    "work income",
    "work pay",
    "compensation",
    "job income",
    "job pay",
    "employee pay"
  ],
  "Maintenance Services": [
    "home services",
    "exterminator",
    "pest control",
    "pest service",
    "termite",
    "bug service",
    "gutter",
    "gutter cleaning",
    "roof cleaning",
    "chimney sweep",
    "pool",
    "pool service",
    "pool maintenance",
    "spa",
    "hot tub",
    "jacuzzi service",
    "pressure washing",
    "power washing",
    "window cleaning",
    "home maintenance",
    "maintenance",
    "handyman",
    "repairman",
    "repairs",
    "yard service",
    "outdoor maintenance",
    "spring cleanup",
    "fall cleanup",
    "HVAC service",
    "air duct cleaning",
    "filter service"
  ],
  "Life Planning / Legal": [
    "legal",
    "law firm",
    "law office",
    "attorney",
    "lawyer",
    "solicitor",
    "barrister",
    "counsel",
    "counselor",
    "at law",
    "at-law",
    "esquire",
    "estate planning",
    "will preparation",
    "living trust",
    "trusts",
    "probate",
    "family law",
    "real estate law",
    "tax attorney",
    "divorce attorney",
    "court",
    "litigation",
    "mediation",
    "legal fees",
    "legal services",
    "notary",
    "legal retainer",
    "law group",
    "law partners",
    "law center",
    "law associates"
  ]
};

export default suggestionRules;